import React from 'react';
import Setting from '../components/settings';

export function Settings({
  setActiveItem,
  initialSection,
  onConsumeInitialSection,
}: {
  setActiveItem: (item: string) => void;
  initialSection?: string | null;
  onConsumeInitialSection?: () => void;
}) {
  return (
    <Setting
      setActiveItem={setActiveItem}
      initialSection={initialSection}
      onConsumeInitialSection={onConsumeInitialSection}
    />
  );
}
